import { Language } from "interfaces/locale";

export type RouteKeys =
  | "login"
  | "entities"
  | "passwordRecovery"
  | "passwordDefinition"
  | "twoFactorAuthentication"
  | "enforcer"
  | "street"
  | "home";

export type ExternalRouteKeys = "certificates" | "landingPage";

export const ROUTES: Record<Language, Record<RouteKeys, string>> = {
  pt: {
    home: "/",
    login: "/entrar",
    entities: "/entidades",
    passwordRecovery: "/recuperar-palavra-passe",
    passwordDefinition: "/definir-palavra-passe",
    twoFactorAuthentication: "/autenticacao-de-dois-fatores",
    enforcer: "/enforcer",
    street: "/street",
  },
  en: {
    home: "/",
    login: "/login",
    entities: "/entities",
    passwordRecovery: "/password-recovery",
    passwordDefinition: "/password-definition",
    twoFactorAuthentication: "/two-factor-authentication",
    enforcer: "/enforcer",
    street: "/street",
  },
  es: {
    home: "/",
    login: "/iniciar-sesion",
    entities: "/entidades",
    passwordRecovery: "/recuperar-contrasena",
    passwordDefinition: "/definir-contrasena",
    twoFactorAuthentication: "/autenticacion-de-dos-factores",
    enforcer: "/enforcer",
    street: "/street",
  },
} as const;

export const EXTERNAL_ROUTES: Record<
  Language,
  Record<ExternalRouteKeys, string>
> = {
  pt: {
    landingPage: `${process.env.REACT_APP_IPARQUE_URL}`,
    certificates: `${process.env.REACT_APP_IPARQUE_URL}sobre#certificates-area`,
  },
  en: {
    landingPage: `${process.env.REACT_APP_IPARQUE_URL}en/`,
    certificates: `${process.env.REACT_APP_IPARQUE_URL}en/about#certificates-area`,
  },
  es: {
    landingPage: `${process.env.REACT_APP_IPARQUE_URL}es/`,
    certificates: `${process.env.REACT_APP_IPARQUE_URL}es/sobre-nosotros#certificates-area`,
  },
};
